/**
 * @generated SignedSource<<6759874c86358848c91cd56402c538bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type cummulativeFlowDiagramComponent_viewer$data = {
  readonly insightComponentsData: {
    readonly tasksFlow: {
      readonly useHours: boolean | null;
      readonly data: ReadonlyArray<{
        readonly dateString: string | null;
        readonly columnsData: ReadonlyArray<{
          readonly id: string;
          readonly statusColumnId: string;
          readonly name: string | null;
          readonly count: number | null;
          readonly sortOrder: number | null;
          readonly forecastSum: number | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "cummulativeFlowDiagramComponent_viewer";
};
export type cummulativeFlowDiagramComponent_viewer$key = {
  readonly " $data"?: cummulativeFlowDiagramComponent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"cummulativeFlowDiagramComponent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isProjectGroupType"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shareKey"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "cummulativeFlowDiagramComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "shareKey",
          "variableName": "shareKey"
        }
      ],
      "concreteType": "InsightComponentsDataType",
      "kind": "LinkedField",
      "name": "insightComponentsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "isProjectGroupType",
              "variableName": "isProjectGroupType"
            },
            {
              "kind": "Variable",
              "name": "projectId",
              "variableName": "projectId"
            }
          ],
          "concreteType": "TasksFlow",
          "kind": "LinkedField",
          "name": "tasksFlow",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "useHours",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksFlowElement",
              "kind": "LinkedField",
              "name": "data",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateString",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TasksFlowStatusColumn",
                  "kind": "LinkedField",
                  "name": "columnsData",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "statusColumnId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "count",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sortOrder",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "forecastSum",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e87ec5445acc9413f9bd48eed33be5f0";

export default node;
